import Layout from "sections/Landing/Layout/LayoutNew";
import { compose } from "@reduxjs/toolkit";
import { graphql } from "gatsby";
import attach from "store";

export default compose(attach)(Layout);

export const query = graphql`
  query ContentfulLandingPageQuery($slug: String!) {
    page: allContentfulLandingPageNewNov2023(filter: { slug: { eq: $slug } }) {
      nodes {
        slug
        pageTitle
        contentBlocks {
          ... on ContentfulKeyFeatures {
            type: __typename
            id
            enabled
          }
          ... on ContentfulLandingPageHeaderContent {
            id
            type: __typename
            mobileBackgroundImage {
              file {
                contentType
                url
                details {
                  image {
                    height
                    width
                  }
                }
              }
            }
            backgroundImage {
              file {
                contentType
                url
                details {
                  image {
                    height
                    width
                  }
                }
              }
            }
            title
            buttonUrl
          }
          ... on ContentfulLandingPageRepeatingContent {
            id
            type: __typename
            buttonText
            buttonUrl
            heading
            image {
              file {
                contentType
                url
              }
            }
            description {
              description
            }
          }
          ... on ContentfulWidgetContainer {
            id
            type: __typename
            content {
              childMarkdownRemark {
                htmlAst
              }
            }
          }
        }
      }
    }
  }
`;
